
/**
 * @export
 * @enum {string}
 */
export enum SectionIconType {
    AGENDA = 'AGENDA',
    ATTENDEES = 'ATTENDEES',
    CC = 'CC',
    DEAL_SOURCE = 'DEAL_SOURCE',
    REPORTS = 'REPORTS',
    SCHEDULE = 'SCHEDULE',
    SPEAKERS = 'SPEAKERS',
    SPONSORS = 'SPONSORS',
    COMPUTER = 'COMPUTER',
    HOME = 'HOME',
    MAP = 'MAP',
    MESSAGES = 'MESSAGES',
    MY_PROFILE = 'MY_PROFILE',
    PITCHBOOK = 'PITCHBOOK'
}